import React from 'react';
import translations from 'services/translations/translations';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import 'style/layout/modals/ModalConfirm.css';

const ModalAccept = ({
  header,
  onApproveCallback,
  showing,
  setShowing,
  text,
}: {
  header: string;
  onApproveCallback: () => void;
  showing: boolean;
  setShowing: (show: boolean) => void;
  text: string;
}): JSX.Element | null => {
  const { t } = useTranslation([translations.common]);
  const toggle = () => setShowing(!showing);

  const getMessage = () =>
    text.split('\n').map((row, index) => (
      <span key={index}>
        {index === 0 ? null : <br />}
        {row}
      </span>
    ));

  const approve = () => {
    onApproveCallback();
    toggle();
  };

  return (
    <>
      <Modal isOpen={showing} toggle={toggle} centered>
        <ModalHeader className="modal-header" toggle={toggle}>
          {header}
        </ModalHeader>
        <ModalBody>{getMessage()}</ModalBody>
        <ModalFooter>
          <Button onClick={toggle} className="modal-button">
            {t(`${translations.common}:Cancel`)}
          </Button>
          <Button onClick={approve} className="modal-button">
            {t(`${translations.common}:OK`)}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default ModalAccept;
